import { Request } from '../../httpClient/serverApi/requests/Request';
import { WorkerProcess } from '../types/WorkerProcess';

export interface IGetServerInfoParams {
}

export interface IGetServerInfoResult {
  workerHosts: string[]; // First host in array is primary
  processes: WorkerProcess[];
}

export class GetServerInfoRequest extends Request<IGetServerInfoParams, IGetServerInfoResult> {
  constructor(params: IGetServerInfoParams) {
    super('getServerInfo', params);
  }
}
